import React, { Component } from 'react';
import Page from '../components/Page';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Segment, Header, Icon, Dropdown, Popup, Form, Modal, Label } from 'semantic-ui-react';
import {
	Box,
	Button,
	Stack,
	Paper,
	Table,
	TableBody,
	TableRow,
	TableHead,
	TableCell,
	Card,
	CardContent,
	Typography,
	Divider,
	TableContainer,
	Radio,
	RadioGroup,
	FormControlLabel,
	TextField,
	FormControl,
	CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { post, toWapi, get } from '../util/api';
import { load_product } from '../actions/product.actions';
import moment from 'moment';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import CircleIcon from '@mui/icons-material/Circle';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import Countries from './settings/countries.json';
import { Link } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import * as GA from '../util/GA';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

const LIVE_PLAN_ID = process.env.REACT_APP_LIVE_PLAN_ID;
const API_PLAN_ID = process.env.REACT_APP_API_PLAN_ID;
const MULTI_API_PLAN_ID = process.env.REACT_APP_MULTI_API_PLAN_ID;
const AGENT_PLAN_ID = process.env.REACT_APP_AGENT_PLAN_ID;
const PHONE_PLAN_ID = process.env.REACT_APP_PHONE_PLAN_ID;
const MULTI_PHONE_PLAN_ID = process.env.REACT_APP_MULTI_PHONE_PLAN_ID;
const HISTORY_DATA_ID = process.env.REACT_APP_HISTORY_DATA_ID;
const INSTAGRAM_PLAN_ID = process.env.REACT_APP_INSTAGRAM_PLAN_ID;
const LIVEAPI_PLAN_ID = process.env.REACT_APP_LIVEAPI_PLAN_ID;
const NEW_PHONE_PLAN_ID = process.env.REACT_APP_PHONE_NEW_PLAN_ID;
const PHONE_19_PLAN_ID = process.env.REACT_APP_PHONE_19_PLAN_ID;
const PHONE_15_PLAN_ID = process.env.REACT_APP_PHONE_15_PLAN_ID;

const options = [];
for (var i = 1; i <= 300; i++) {
	options.push({ key: '' + i, text: '' + i, value: i });
}

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

const Questions = [
	{ title: 'Does not meet my needs', state: 'feedback_need', textbox: true, textboxText: 'What is your needs?' },
	{ title: 'Technical issues', state: 'feedback_technical', textbox: true, textboxText: 'What is the technical problem?' },
	{ title: 'Too expensive', state: 'feedback_expensive', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'Switching to another provider', state: 'feedback_provider', textbox: true, textboxText: 'Which will you use other provider?' },
	{ title: 'Not enough support from MAYTAPI team', state: 'feedback_team', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'I will buy again', state: 'feedback_iwill_buy_later', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'Other', state: 'feedback_other', textbox: true, textboxText: "Anything you'd like to share?" },
];

class Payment extends Component {
	state = {
		loading: true,
		update: false,
		open: false,
		openNew: false,
		openCreate: false,
		openPopup: false,
		openChangePopup: false,
		previewModal: false,
		unsubscribe: false,
		messageOnScreen: null,
		messageColor: 'yellow',
		unsubscribeTrial: false,
		feedbackText: '',
		feedbackOption: '',
		packageName: '',
		feedbackTitle: '',
		disableSubButton: true,
		disableSubCancelButton: false,
		loadSubButton: false,
		plan_id: '',
		subscription_id: '',
		user_id: '',
		quantity_id: '',
		buyWait: false,
		crPhoneQu: 1,
		crAgentQu: 1,
		quantityUpdate: 1,
		quantity: _.get(this.props, 'product.settings.phone_limit') || 1,
		quantityAgent: _.get(this.props, 'product.settings.agent_limit') || 1,
		options,
		plans: this.props.product.settings.subscription_package || 'api',
		trialButtonLoading: false,
		trialButtonLoadingApi: false,
		trialButtonLoadingLive: false,
		trialButtonLoadingInstagram: false,
		trialSuccess: false,
		billDate: '',
		planChangeModal: false,
		purchaseModal: false,
		companyName: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.name) || '',
		vatNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.vatNumber) || '',
		companyCountry: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.country) || '',
		companyCity: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.city) || '',
		companyState: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.state) || '',
		companyPostCode: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.postcode) || '',
		companyStreet: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.street) || '',
		isVat: false,
		select_date: new Date(),
		historyData: false,
		openPopup19: false,
		openPopup19Update: false,
		phoneTextModal: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		convertPhoneNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		phoneTextModalStatus: false,
		purschaseTextModal: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		convertPurschaseNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		purschasephoneTextModalStatus: false,
	};

	componentDidMount() {
		this.getPartnerLogs();
	}

	async getPartnerLogs() {
		let { product } = this.props;
		let { id } = product;
		let month = (/month/.test(window.location.search) && window.location.search.replace('?month=', '')) || moment().month() + 1;
		console.log('month', month);
		let result = await get('/maytapi/getPartnerLogs?month=' + month, { pid: id });
		console.log('result.status', result);
		let logs = result.results;
		logs = _.filter(logs, (it) => it.phone_id);
		this.setState({ partnerLogs: logs, loading: false });
	}

	closeModal = () => {
		this.setState({
			open: false,
			unsubscribe: false,
			openCreate: false,
			openNew: false,
			unsubscribeTrial: false,
			trialSuccess: false,
			planChangeModal: false,
			previewModal: false,
			purchaseModal: false,
			historyModal: false,
			trialChangeModal: false,
			helpModal: false,
			restartModal: false,
		});
	};

	PLANS = {
		API: `${API_PLAN_ID}`,
		MULTIAPI: `${MULTI_API_PLAN_ID}`,
		LIVE: `${LIVE_PLAN_ID}`,
		PHONE: `${PHONE_PLAN_ID}`,
		NEWPHONE: `${NEW_PHONE_PLAN_ID}`,
		NEWPHONE19: `${PHONE_19_PLAN_ID}`,
		NEWPHONE15: `${PHONE_15_PLAN_ID}`,
		MULTIPHONE: `${MULTI_PHONE_PLAN_ID}`,
		AGENT: `${AGENT_PLAN_ID}`,
		HISTORY: `${HISTORY_DATA_ID}`,
		INSTAGTAM: `${INSTAGRAM_PLAN_ID}`,
		LIVEAPI: `${LIVEAPI_PLAN_ID}`,
		'TRIAL-API': 'maytapi-trial-api',
		'TRIAL-LIVE': 'maytapi-trial-live',
		'TRIAL-MULTIAPI': 'maytapi-trial-multi-api',
		[INSTAGRAM_PLAN_ID]: 'INSTAGRAM',
		[PHONE_PLAN_ID]: 'PHONE',
		[NEW_PHONE_PLAN_ID]: 'PHONE',
		[PHONE_19_PLAN_ID]: 'PHONE19',
		[PHONE_15_PLAN_ID]: 'PHONE15',
		[MULTI_PHONE_PLAN_ID]: 'MULTIPHONE',
		[AGENT_PLAN_ID]: 'AGENT',
		[LIVE_PLAN_ID]: 'LIVE',
		[API_PLAN_ID]: 'API',
		[MULTI_API_PLAN_ID]: 'MULTIAPI',
		[HISTORY_DATA_ID]: 'HISTORY',
		[LIVEAPI_PLAN_ID]: 'LIVEAPI',
		'maytapi-trial-live': 'TRIAL-LIVE',
		'maytapi-trial-api': 'TRIAL-API',
		'maytapi-trial-multi-api': 'TRIAL-MULTIAPI',
	};

	getPaymentHistory = (value) => async () => {
		await post('/maytapi/getPaymentHistory', { subscription_id: value.subscription_id, pid: this.state.pid }).then((data) => {
			this.setState({ paymentHistory: _.orderBy(data.data.response, 'id', 'desc'), historyModal: true });
		});
	};

	updatePayment = (value) => async () => {
		let data = await post('/maytapi/getsubsdetails', { pid: this.props.product.id, subscription_id: value.subscription_id });
		let update_url = data.data && data.data.response && data.data.response[0].update_url;
		window.Paddle.Checkout.open({
			override: update_url,
			passthrough: {
				pid: this.props.product.id,
			},
		});
	};

	calculateStatusCounts = (phone_subs) => {
		let statusCounts = {
			live: 0,
			closed: 0,
			trial: 0,
		};

		phone_subs.forEach((sub) => {
			let status = sub.data.status;
			if (statusCounts.hasOwnProperty(status)) {
				statusCounts[status]++;
			}
		});

		return statusCounts;
	};

	calculateTotalCount = (partnerLogs) => {
		return _.sumBy(partnerLogs, (it) => {
			return it.live_days_total > 0 ? 1 : 0;
		});
	};

	calculatePhonePrice = (live_days_total) => {
		let phone_unit = this.props.product.settings.phone_unit || 30;
		return live_days_total > 0 ? phone_unit : 0;
	};

	calculateTotalPrice = (partnerLogs) => {
		let phone_unit = this.props.product.settings.phone_unit || 30;
		return _.sumBy(partnerLogs, (it) => {
			return it.live_days_total > 0 ? phone_unit : 0;
		});
	};

	render() {
		if (this.state.loading)
			return (
				<Page title="Subscription" icon={<ShoppingCartIcon />}>
					<Page.Loader />
				</Page>
			);

		let { partnerLogs } = this.state;
		let products = this.props.product;
		let settings = products.settings;
		let phone_unit = settings.phone_unit || 30;

		let orderList = _.filter(_.orderBy(products.activeSubs, ['id'], ['asc']), function (o) {
			return o.data.subscription_plan_id && !o.data.phone_id;
		});

		let deletedList = _.filter(_.orderBy(products.deletedSubs, ['id'], ['asc']), function (o) {
			return o.data.subscription_plan_id;
		});

		let trial = products.trial;
		let f_trial = false;
		let trialEndDate = products.activeSubs[0] && moment(products.activeSubs[0].created_at).startOf('day').add('3', 'days');
		let diffDate = moment(trialEndDate).diff(moment().startOf('day'), 'days');

		const { quantityUpdate, crPhoneQu } = this.state;

		let phoneSubs =
			_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${NEW_PHONE_PLAN_ID}` } }) ||
			_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_PLAN_ID}` } }) ||
			'';
		let phoneSubs19 = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_19_PLAN_ID}` } }) || '';
		let phoneSubs15 = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_15_PLAN_ID}` } }) || '';
		let agentSubs = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${AGENT_PLAN_ID}` } }) || '';

		var trials = { 'maytapi-trial-api': 'API', 'maytapi-trial-live': 'LiveChat' };
		let subscription = products.settings && products.settings.subscription_package && trials[products.settings.subscription_package];
		let expiredTrialType =
			products.trial === false &&
			products.deletedSubs &&
			products.deletedSubs[0] &&
			products.deletedSubs[0].data.trialType &&
			trials[products.deletedSubs[0].data.trialType];

		let sub_status = {
			past_due: {
				color: 'error',
				text: 'Past Due',
			},
			active: {
				color: 'success',
				text: 'Active',
			},
			deleted: {
				color: 'text',
				text: 'Cancelled',
			},
			paused: {
				color: 'warning',
				text: 'Paused',
			},
			live: {
				color: 'success',
				text: 'Live',
			},
			closed: {
				color: 'warning',
				text: 'Closed',
			},
		};

		let account_phone = products.settings.phone25 ? NEW_PHONE_PLAN_ID : PHONE_PLAN_ID;
		let account_phone_price = products.settings.phone25 ? 25 : 30;

		let all_subs = _.concat(products.activeSubs, products.deletedSubs);
		console.log('products', all_subs, partnerLogs);
		let phone_subs = _.filter(all_subs, (it) => it.data.phone_id);

		// Status sayaçlarını hesapla
		let statusCounts = this.calculateStatusCounts(phone_subs);

		// Toplam fiyatı hesapla
		let totalPrice = this.calculateTotalPrice(partnerLogs);

		return (
			<Page title="Partner" icon={<ShoppingCartIcon />}>
				<style
					dangerouslySetInnerHTML={{
						__html: `
						.ui.page.modals.dimmer{
							z-index:999999999999 ;
						}`,
					}}
				/>
				<Box sx={{ padding: '30px' }}>
					<Stack sx={{ margin: 'auto', padding: '0', boxShadow: 'rgb(0 0 0 / 15%) 0px 5px 15px 0px', borderRadius: '8px' }}>
						<div style={{ marginTop: '20px' }}>
							<div style={{ textAlign: 'center' }}>
								<h3>Partner Subscription</h3>
								<p>You can't increase phones Partner Subscripton.</p>
								<p>If you want more phones, you have to contact us.</p>
							</div>
							<div style={{ marginTop: '20px', marginBottom: '20px' }}>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<a href="/contact">
										<Button variant="contained" color="primary">
											Contact Us
										</Button>
									</a>
								</div>
							</div>
							<Divider></Divider>

							{/* Status Sayaçları */}
							<div style={{ display: 'flex', justifyContent: 'center', gap: '20px', padding: '20px' }}>
								<Paper
									sx={{
										padding: '15px 30px',
										textAlign: 'center',
										minWidth: '100px',
										border: '2px solid #4caf50',
									}}
								>
									<Typography variant="h4" color="success.main">
										{this.calculateTotalCount(partnerLogs)}
									</Typography>
									<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
										Total Live
									</Typography>
								</Paper>
								<Paper
									sx={{
										padding: '15px 30px',
										textAlign: 'center',
										minWidth: '100px',
										border: '2px solid #4caf50',
									}}
								>
									<Typography variant="h4" color="success.main">
										{statusCounts.live}
									</Typography>
									<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
										Current Live
									</Typography>
								</Paper>
								<Paper
									sx={{
										padding: '15px 30px',
										textAlign: 'center',
										minWidth: '100px',
										border: '2px solid #ff9800',
									}}
								>
									<Typography variant="h4" color="warning.main">
										{statusCounts.closed}
									</Typography>
									<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
										Closed
									</Typography>
								</Paper>
								<Paper
									sx={{
										padding: '15px 30px',
										textAlign: 'center',
										minWidth: '100px',
										border: '2px solid #2196f3',
									}}
								>
									<Typography variant="h4" color="info.main">
										{statusCounts.trial}
									</Typography>
									<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
										Trial
									</Typography>
								</Paper>
							</div>

							<Divider></Divider>
							<div style={{ display: 'flex', padding: '10px' }}>
								<h3 style={{ margin: 'auto' }}>Phone Limit: {settings.phone_limit}</h3>
							</div>
							<Divider></Divider>
							<TableContainer sx={{ maxHeight: 440 }}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell width="1">Subscription</TableCell>
											<TableCell width="2">Status</TableCell>
											<TableCell width="1">Next Bill Date</TableCell>
											{/* <TableCell width="2">Next Payment Amount</TableCell> */}
											<TableCell width="6" style={{ textAlign: 'right' }}>
												Actions
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{!products.activeSubs
											? {}
											: _.map(orderList, (data, i) => (
													<TableRow key={i}>
														<TableCell>
															<strong>Partner</strong>
														</TableCell>
														<TableCell>
															<Stack spacing={2} direction="row">
																<CircleIcon
																	color={
																		(data.data.subscription_plan_id === 'maytapi-custom-api'
																			? 'success'
																			: data.data.status &&
																			  sub_status[data.data.status] &&
																			  sub_status[data.data.status].color) || 'disabled'
																	}
																	fontSize="small"
																/>
																<strong>
																	{(data.data.status && sub_status[data.data.status] && sub_status[data.data.status].text) ||
																		''}
																</strong>
															</Stack>
														</TableCell>
														{data.data.status === 'past_due' ? (
															<TableCell>
																<Stack spacing={4}>
																	<p style={{ marginBottom: 0 }}>
																		Last Try Date: <strong>{moment(data.data.event_time).format('DD-MM-YYYY')}</strong>
																	</p>
																	<p style={{ marginTop: 0 }}>
																		Next Try Date: <strong>{moment(data.data.next_retry_date).format('DD-MM-YYYY')}</strong>
																	</p>
																	<p style={{ marginTop: 0 }}>
																		Payment Attempts: <strong>{data.data.attempt_number || 1}</strong>
																	</p>
																	<p style={{ marginTop: 0 }}>
																		Attempts Remaining: <strong>{4 - parseInt(data.data.attempt_number || 1)}</strong>
																	</p>
																</Stack>
															</TableCell>
														) : (
															<TableCell>
																{this.PLANS[data.data.subscription_plan_id || data.data.product_id] !== 'HISTORY'
																	? data.data.next_bill_date
																	: 'One-off Purchase'}
															</TableCell>
														)}

														{/* <TableCell>
															<strong>{totalPrice} $</strong>
														</TableCell> */}

														<TableCell style={{ textAlign: 'right', display: 'flex' }}>
															{(data.custom_data && data.custom_data.subscription_plan_id === 'maytapi-custom-api') ||
															data.data.subscription_plan_id === 'maytapi-custom-api' ? (
																<div style={{ marginLeft: 'auto', display: 'flex' }}>
																	{data.data.subscription_id ? (
																		<div
																			className="payment-buttons"
																			size="mini"
																			style={{ display: 'flex', marginLeft: 'auto' }}
																		>
																			<Button
																				color="success"
																				size="small"
																				variant="contained"
																				onClick={this.getPaymentHistory({
																					subscription_id: data.data.subscription_id,
																				})}
																			>
																				Invoice
																			</Button>
																			<Button
																				disabled={data.data.status === 'temporary'}
																				size="small"
																				color="info"
																				variant="contained"
																				sx={{ marginLeft: '10px' }}
																				onClick={this.updatePayment({
																					subscription_id: data.data.subscription_id,
																				})}
																			>
																				Update Payment Method
																			</Button>
																			<a href="/contact">
																				<Button size="small" variant="contained" color="primary">
																					Contact Us
																				</Button>
																			</a>
																		</div>
																	) : (
																		<a href="/contact">
																			<Button size="small" variant="contained" color="primary">
																				Contact Us
																			</Button>
																		</a>
																	)}
																</div>
															) : this.PLANS[data.data.subscription_plan_id] === 'LIVE' ||
															  this.PLANS[data.data.subscription_plan_id] === 'API' ||
															  this.PLANS[data.data.subscription_plan_id] === 'LIVEAPI' ? (
																<div className="payment-buttons" size="mini" style={{ display: 'flex', marginLeft: 'auto' }}>
																	{data.data.status === 'paused' ? (
																		<Button
																			color="warning"
																			size="small"
																			variant="contained"
																			onClick={this.reActiveSub({ subscription_id: data.data.subscription_id })}
																		>
																			Restart
																		</Button>
																	) : (
																		''
																	)}
																	<Button
																		color="success"
																		size="small"
																		variant="contained"
																		sx={{ marginLeft: '10px' }}
																		onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																	>
																		Invoice
																	</Button>
																	<Button
																		disabled={data.data.status === 'temporary'}
																		size="small"
																		color="info"
																		variant="contained"
																		sx={{ marginLeft: '10px' }}
																		onClick={this.updatePayment({ subscription_id: data.data.subscription_id })}
																	>
																		Update Payment Method
																	</Button>
																	<Popup
																		header="You can't unsubscribe before cancelling other subscriptions."
																		content="Please unsubscribe from other plans."
																		open={this.state.openPopup}
																		position="top center"
																		style={{ zIndex: 1 }}
																		trigger={
																			<Button
																				disabled={data.data.status === 'temporary'}
																				color="error"
																				variant="contained"
																				onClick={() => {
																					products.activeSubs.length > 1
																						? this.openPop('openPopup')
																						: this.setState({
																								helpModal: true,
																								subscription_id:
																									(data && data.data && data.data.subscription_id) || '',
																								plan_id:
																									(data && data.data && data.data.subscription_plan_id) || '',
																								user_id: (data && data.data && data.data.user_id) || '',
																								quantity_id:
																									(data && data.data && data.data.quantity) ||
																									data.data.new_quantity ||
																									'',
																						  });
																				}}
																				size="small"
																				sx={{ marginLeft: '10px' }}
																			>
																				Unsubscribe
																			</Button>
																		}
																	/>
																</div>
															) : data.data.nobuttons ? null : (
																<div className="payment-buttons" size="mini" style={{ display: 'flex', marginLeft: 'auto' }}>
																	<Button
																		color="success"
																		size="small"
																		variant="contained"
																		onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																	>
																		Invoice
																	</Button>
																	<Button
																		disabled={data.data.status === 'temporary'}
																		size="small"
																		color="info"
																		variant="contained"
																		sx={{ marginLeft: '10px' }}
																		onClick={this.updatePayment({ subscription_id: data.data.subscription_id })}
																	>
																		Update Payment Method
																	</Button>
																	<Popup
																		header="You can't edit PHONE subscription before cancelling PHONE19."
																		content="Please unsubscribe from PHONE19 plan."
																		open={
																			this.PLANS[data.data.subscription_plan_id] === 'PHONE' &&
																			this.state.openPopup19Update
																		}
																		position="top center"
																		style={{ zIndex: 1 }}
																		trigger={
																			<Button
																				disabled={data.data.status === 'temporary'}
																				color="success"
																				variant="contained"
																				onClick={() => {
																					this.PLANS[data.data.subscription_plan_id] === 'PHONE' && phoneSubs19
																						? this.openPop('openPopup19Update')
																						: this.openModal({
																								selectedSubs: data.data.subscription_id,
																								user_id: data.data.user_id,
																								plan_id: data.data.subscription_plan_id,
																								price:
																									this.PLANS[data.data.subscription_plan_id] === 'AGENT'
																										? 20
																										: this.PLANS[data.data.subscription_plan_id] ===
																										  'PHONE19'
																										? 19
																										: this.PLANS[data.data.subscription_plan_id] ===
																										  'PHONE15'
																										? 15
																										: account_phone_price,
																								old_quantity: data.data.quantity || data.data.new_quantity,
																						  });
																				}}
																				size="small"
																				sx={{ marginLeft: '10px' }}
																			>
																				Update
																			</Button>
																		}
																	/>
																	<Popup
																		header="You can't edit PHONE subscription before cancelling PHONE19."
																		content="Please unsubscribe from PHONE19 plan."
																		open={this.PLANS[data.data.subscription_plan_id] === 'PHONE' && this.state.openPopup19}
																		position="top center"
																		style={{ zIndex: 1 }}
																		trigger={
																			<Button
																				disabled={data.data.status === 'temporary'}
																				color="error"
																				variant="contained"
																				onClick={() => {
																					this.PLANS[data.data.subscription_plan_id] === 'PHONE' && phoneSubs19
																						? this.openPop('openPopup19')
																						: this.setState({
																								helpModal: true,
																								packageName: 'subscription',
																								subscription_id:
																									(data && data.data && data.data.subscription_id) || '',
																								plan_id:
																									(data && data.data && data.data.subscription_plan_id) || '',
																								user_id: (data && data.data && data.data.user_id) || '',
																								quantity_id:
																									(data && data.data && data.data.quantity) ||
																									data.data.new_quantity ||
																									'',
																						  });
																				}}
																				size="small"
																				sx={{ marginLeft: '10px' }}
																			>
																				Unsubscribe
																			</Button>
																		}
																	/>
																</div>
															)}
														</TableCell>
													</TableRow>
											  ))}
									</TableBody>
								</Table>
							</TableContainer>
							<Divider></Divider>
							<div style={{ display: 'flex', padding: '10px' }}>
								<TableContainer component={Paper} sx={{ padding: '0' }}>
									<Table sx={{ background: '#fafafa' }}>
										<TableHead>
											<TableRow>
												<TableCell>Phone</TableCell>
												<TableCell>Last Mod</TableCell>
												<TableCell>Live days of This Month</TableCell>
												{/* <TableCell>Price</TableCell> */}
												<TableCell>Update Date</TableCell>
												<TableCell>Details</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{console.log('partnerLogs', partnerLogs)}
											{/* <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
												<TableCell>
													<strong>Total</strong>
												</TableCell>
												<TableCell></TableCell>
												<TableCell></TableCell>
												<TableCell>
													<strong>{totalPrice + ' $'}</strong>
												</TableCell>
												<TableCell></TableCell>
												<TableCell></TableCell>
											</TableRow> */}
											{phone_subs &&
												_.map(phone_subs, (sub, i) => {
													let partner_log = _.find(partnerLogs, (it) => _.parseInt(it.phone_id) === _.parseInt(sub.data.phone_id));
													console.log('-------------------partner_log', sub, partner_log);
													let logs = partner_log && partner_log.logs;
													let first_log = logs && _.last(logs);
													let last_log = partner_log && partner_log.last_log;
													let live_days = partner_log && partner_log.live_days_total;
													let price = this.calculatePhonePrice(live_days);

													return (
														<TableRow key={i}>
															<TableCell>{sub.data.phone_id}</TableCell>
															<TableCell>{sub.data.status}</TableCell>
															<TableCell>{live_days || 0}</TableCell>
															{/* <TableCell>{price + ' $'}</TableCell> */}
															<TableCell>
																{last_log && last_log.date && moment(last_log.date).format('DD-MM-YYYY HH:mm')}
															</TableCell>
															<TableCell></TableCell>
														</TableRow>
													);
												})}
										</TableBody>
									</Table>
								</TableContainer>
							</div>
						</div>
					</Stack>
				</Box>
				<Modal open={this.state.historyModal} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
					<Header icon="dollar" content="Payment History" />
					<Modal.Content>
						<h4>Next Payment</h4>
						{_.map(_.filter(this.state.paymentHistory, { is_paid: 0 }), function (it) {
							return (
								<a
									href={it.is_paid ? it.receipt_url : null}
									target="_blank"
									rel="noopener noreferrer"
									key={it.id}
									style={{
										display: 'flex',
										color: '#646464',
										padding: '14px',
										flex: ' 0 0 auto',
										textDecoration: 'none',
										border: '1px solid rgb(221, 221, 221)',
										fontSize: '600',
									}}
								>
									<div style={{ width: '70%' }}>
										<div style={{ fontWeight: '600' }}>{'OrderCode: ' + it.id}</div>
										<div style={{ fontWeight: '600' }}>
											{'Next Bill Date: ' + moment(it.payout_date, 'YYYY-MM-DD').format('MMM DD, YYYY')}
										</div>
									</div>
									<div>
										<div style={{ fontWeight: '600' }}>{'$' + it.amount}</div>
									</div>
								</a>
							);
						})}
					</Modal.Content>
					<Modal.Content style={{ paddingTop: '0', paddingBottom: '0' }}>
						<h4>Past Payments</h4>
					</Modal.Content>
					<Modal.Content scrolling>
						<div style={{ borderTop: '1px solid rgb(221, 221, 221)', borderRadius: '4px', display: 'flex' }}></div>
						{_.map(_.filter(this.state.paymentHistory, { is_paid: 1 }), function (it) {
							return (
								<a
									href={it.is_paid ? it.receipt_url : null}
									target="_blank"
									rel="noopener noreferrer"
									key={it.id}
									style={{
										display: 'flex',
										color: '#646464',
										padding: '14px',
										flex: ' 0 0 auto',
										textDecoration: 'none',
										border: '1px solid rgb(221, 221, 221)',
										borderTop: 'none',
										fontSize: '600',
									}}
								>
									<div style={{ width: '70%' }}>
										<div style={{ fontWeight: '600' }}>{'Order Code: ' + it.id}</div>
										<div style={{ fontWeight: '600' }}>{'Date: ' + moment(it.payout_date, 'YYYY-MM-DD').format('MMM DD, YYYY')}</div>
									</div>
									<div>
										<div style={{ fontWeight: '600' }}>{'$' + it.amount}</div>
										<div style={{ textDecoration: 'underline', color: 'black', fontWeight: '400' }}>Show Receipt</div>
									</div>
								</a>
							);
						})}
					</Modal.Content>
				</Modal>
			</Page>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.maytapi,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(Payment);
